import { Button } from "antd";
import Colors from "../../../../assets/Colors";
import s from "./styles";
import Pencil from "../../../icons/Pencil";
import Trash from "../../../icons/Trash";
import Eye from "../../../icons/EyeIcon";

function ItemRow({
  columns,
  rowRenderer,
  line = true,
  grid,
  handleDeleteItem,
  handleEditItem,
  handleShowDetails,
  showDetails,
  keyId,
  moreOption = true,
  deleteOption = true,
  item,
}) {
  const buttons = (
    <div
      style={{
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        paddingRight: 20,
      }}
    >
      {showDetails && (
        <Button
          icon={<Eye size={14} color={Colors.text_primary} />}
          type="text"
          onClick={() => {
            handleShowDetails();
          }}
        />
      )}
      {handleEditItem && !showDetails && (
        <Button
          icon={<Pencil size={14} color={Colors.text_primary} />}
          type="text"
          onClick={() => {
            handleEditItem(item);
          }}
        />
      )}
      {deleteOption && !showDetails && (
        <Button
          icon={<Trash size={14} color={Colors.text_primary} />}
          type="text"
          onClick={() => {
            handleDeleteItem();
          }}
        />
      )}
    </div>
  );

  return (
    <>
      <s.RowWrapper key={keyId} columns={columns?.length + 1} grid={grid}>
        {rowRenderer ? (
          rowRenderer()
        ) : (
          <>
            {columns &&
              columns.map((r, i) => (
                <s.TableCell
                  onClick={() => {
                    handleEditItem && moreOption && handleEditItem(item);
                  }}
                  key={`${i}-${keyId}`}
                >
                  {r || "-"}
                </s.TableCell>
              ))}
          </>
        )}
        {moreOption && buttons}
      </s.RowWrapper>
      {line && <s.Line key={`line-${keyId}`} columns={columns?.length + 1} />}
    </>
  );
}

export default ItemRow;
